/// <reference path="aiChat.module.ts" />

module Meevo.Components.AiChat {

    export interface IAiChatController extends ng.IScope {

    }

    export class AiChatController {
        public isElementReady: boolean = false;
        public isLoaded: boolean = false;
        public color: string = "";
        public mode: string = "";
        public userName: string = "";
        public isPinned: boolean = false;
        public isDetached: boolean = false;
        public isMsiUser: boolean = false;
        private rootScope: ng.IRootScopeService;
        private static scriptLoaded: boolean = false;
        static $inject = ["$rootScope", "$scope", "$timeout", "meevo.components.common.IdentityService", "meevo.components.modal.ModalService", "meevo.components.aichat.AiChatService", "meevo.AppSettings"];
        constructor(private $rootScope: ng.IRootScopeService,
            protected $scope: ng.IScope,
            private $timeout: ng.ITimeoutService,
            protected identityService: Meevo.Components.Common.IIdentityService,
            protected modalService: Meevo.Components.Modal.IModalService,
            private aiChatService: Meevo.Components.AiChat.IAiChatService,
            private appSettings: Meevo.Components.Common.IAppSettings) {
            let vm = this;
            vm.rootScope = $rootScope;
            let isCentralOffice = () => this.identityService.inCentralOfficeMode();
            let isSingleLocation = () => this.identityService.isSingleLocation();
            vm.mode = isSingleLocation() ? "single-location" : (isCentralOffice() ? "central-office" : "multi-location");

            $rootScope.$on(Meevo.Components.Common.Messages.OPEN_AICHAT_COMPLETE, (event, args) => {
                // Only the legacy (non-enhanced) nav injects the navbar color; the
                // enhanced nav uses a fixed neutral surface and passes no color.
                if (!vm.isEnhancedGlobalNav) {
                    let navbar = document.querySelector('#meevo-navbar');
                    if (navbar) {
                        vm.color = vm.rgbToHex(window.getComputedStyle(navbar).backgroundColor);
                    }
                }
                vm.isLoaded = true;
                vm.aiChatService.ensureElement(vm.getOptions());
                if (vm.isDetached) {
                    vm.openAiChatModal();
                } else {
                    $timeout(() => vm.aiChatService.attachTo(AiChatService.HOST_ID), 0);
                }
            });

            $rootScope.$on(Meevo.Components.Common.Messages.RESTART_AICHAT, (event, args) => {
                vm.aiChatService.restart(vm.getOptions());
                $timeout(() => vm.aiChatService.attachTo(vm.isDetached ? AiChatService.MODAL_HOST_ID : AiChatService.HOST_ID), 0);
            });

            vm.userName = this.identityService.current().firstName || this.identityService.current().userName;
            vm.isMsiUser = identityService.current().userTypeEnum === Model.UserTypeEnum.MSIUser;
            vm.loadChatScript();
        }

        $onInit() {
            var chatDetached = localStorage.getItem("mil:meevo:chatdetached");
            if (chatDetached) {
                this.isDetached = chatDetached === "true";
            }
        }

        // Enhanced nav uses the new neutral/Prism look; legacy keeps the injected color.
        // Read from the business-info setting (available synchronously at bootstrap) so the
        // toolbar paints the correct look on first render instead of flashing the legacy
        // look until the panel opens.
        public get isEnhancedGlobalNav(): boolean {
            return !!(this.appSettings.APP_BUSINFOSETTINGS
                && this.appSettings.APP_BUSINFOSETTINGS.generalSettings
                && this.appSettings.APP_BUSINFOSETTINGS.generalSettings.enableEnhancedGlobalNavigation);
        }

        private getOptions(): IAiChatOptions {
            return {
                color: this.isEnhancedGlobalNav ? "" : this.color,
                userName: this.userName,
                mode: this.mode,
                isMsiUser: this.isMsiUser,
                isEnhancedGlobalNav: this.isEnhancedGlobalNav
            };
        }

        initializeElement(): void {
            this.$timeout(() => {
                this.isElementReady = true;
            });
        }

        togglePinnedMenu(): void {
            this.isPinned = !this.isPinned;
        }

        toggleDetached() : void {
            this.isDetached = !this.isDetached;
            if (this.isDetached) {
                this.aiChatService.detach();
                this.openAiChatModal();
                this.rootScope.$broadcast(Meevo.Components.Common.Messages.DETACH_AICHAT, null);
            } else {
                this.aiChatService.detach();
                this.modalService.hide();
                this.$timeout(() => this.aiChatService.attachTo(AiChatService.HOST_ID), 0);
            }
            localStorage.setItem("mil:meevo:chatdetached", this.isDetached.toString());
        }

        public openAiChatModal() : void {
            let callbacks : Meevo.Components.AiChat.IAiChatCallbacks = {
                onClose: this.closeMenu.bind(this),
                onMinimize: this.minimizeMenu.bind(this),
                onReattach: this.toggleDetached.bind(this)
            }

            let modalOptions: Meevo.Components.Modal.IModalOptions = {
                templateUrl: "app/components/aiChat/aiChatModal.template.html",
                controller: "meevo.components.aichat.AiChatModalController",
                controllerAs: "vm",
                bindToController: true,
                escapeToClose: true,
                hasBackdrop: false,
                fullscreen: true,
                locals: {
                    options: this.getOptions(),
                    callbacks: callbacks
                }
            }
            this.modalService.showCustom(modalOptions);
        }


        minimizeMenu(): void {
            this.modalService.hide();
            this.$rootScope.$broadcast('minimizeAiChat');
        }

        closeMenu(): void {
            this.modalService.hide();
            this.aiChatService.restart(this.getOptions());
            this.$rootScope.$broadcast('closeAiChat');
        }

        pinMenu(): void {
            this.isPinned = !this.isPinned;
        }

        loadChatScript(): void {
            if (AiChatController.scriptLoaded) return;
            AiChatController.scriptLoaded = true;
            const version = sessionStorage.getItem("mil:meevo:aiversion") || new Date().toISOString().split('T')[0];
            const src = `${this.aiChatService.baseUrl}/assets/meevo-ai-chat.js?v=${version}`;
            const script = document.createElement('script');
            script.async = true;
            script.src = src;
            document.head.appendChild(script);
        }

        rgbToHex(rgb: string): string {
            let sep = rgb.indexOf(",") > -1 ? "," : " ";
            let rgbArray: string[] = rgb.substr(4).split(")")[0].split(sep);

            let r = (+rgbArray[0]).toString(16),
                g = (+rgbArray[1]).toString(16),
                b = (+rgbArray[2]).toString(16);

            if (r.length == 1)
                r = "0" + r;
            if (g.length == 1)
                g = "0" + g;
            if (b.length == 1)
                b = "0" + b;

            return "#" + r + g + b;
        }

    }


    angular.module("meevo.components.aichat")
        .controller("meevo.components.aichat.AiChatController", AiChatController);
}
